import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import CalenderIcon from "../../Icons/CalendarIcon";
import { DateTime } from "luxon";
import { ReuseInputGroup } from "@locoworks/reusejs-react-input-group";
import { twMerge } from "tailwind-merge";
import { useOutsideClicker } from "@locoworks/reusejs-toolkit-react-hooks";
import "react-calendar/dist/Calendar.css";
import { CalendarIcon } from "../..";

interface CalendarInputProps {
  searchForm: any;
  dateName: string;
  showDateName?: string;
  headerText?: string;
  wrapperClassName?: string;
  className?: string;
}
const CalendarInput: React.FC<CalendarInputProps> = ({
  searchForm,
  dateName,
  showDateName,
  headerText,
  wrapperClassName,
  className,
}) => {
  const [date, setDate] = useState(
    DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")
  );
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    const reactCalendar: any = document.querySelectorAll(".react-calendar");
    if (reactCalendar) {
      reactCalendar[0].style.maxWidth = "300px";
      reactCalendar[1].style.maxWidth = "300px";
    }
  }, [showCalendar]);
  useEffect(() => {
    if (searchForm.value.startDate == "" && searchForm.value.endDate == "") {
      setDate(DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd"));
    }
  }, [searchForm.value.startDate, searchForm.value.endDate]);

  const handleSetCalendar = () => {
    setShowCalendar(false);
  };
  const outsideClicker = useOutsideClicker(() => {
    handleSetCalendar && handleSetCalendar();
  });

  const validateDate = (date: Date) => {
    const startDate = searchForm.value.startDate;
    const endDate = searchForm.value.endDate;

    if (dateName === "endDate" && startDate && date < new Date(startDate)) {
      alert("End Date cannot be earlier than Start Date");
      return false;
    }

    if (dateName === "startDate" && endDate && date > new Date(endDate)) {
      alert("Start Date cannot be later than End Date");
      return false;
    }
    return true;
  };

  const getValue = () => {
    const selectedDate = searchForm.value[dateName];
    if (selectedDate) {
      return selectedDate;
    }
    return "Select Date...";
  };

  return (
    <div className={twMerge("relative", wrapperClassName)}>
      <ReuseInputGroup
        onChange={(e: any) => {}}
        onClick={() => setShowCalendar((prev) => !prev)}
        value={getValue()}
        wrapperClasses="w-full"
        className="w-full border border-gray-300 text-sm mt-1"
        headerText={headerText}
        placeholder="Select Date..."
        suffix={
          <div
            onClick={() => setShowCalendar(true)}
            className="absolute top-[50px] -translate-y-1/2 right-2 font-bold"
          >
            <CalendarIcon color="blue" width="23" height="24" />
          </div>
        }
      />
      <div ref={outsideClicker} className="">
        <Calendar
          className={twMerge(
            `absolute top-0 right-0 border-0 z-50 react-calendar`,
            showCalendar ? " max-w-[200px]" : "hidden"
          )}
          onClickDay={(date: Date) => {
            if (validateDate(date)) {
              searchForm.setField(
                dateName,
                DateTime.fromJSDate(date).toFormat("yyyy-MM-dd")
              );
            }
            setShowCalendar(false);
          }}
          value={searchForm.value[dateName] || new Date()}
        />
      </div>
    </div>
  );
};

export default CalendarInput;
